module.exports = __webpack_public_path__ + "img/storno.b0fb20d0.svg";